export default "__VITE_ASSET__67dccccf__"